export const getCheckoutPayload = async (
  bookingDetails,
  cartItems,
  cardDetails,
  payAmount
) => {
  const payload = {
    booking_id: bookingDetails.booking_id,
  };

  if (cardDetails) {
    payload.card_details = {
      first_name: cardDetails.first_name,
      last_name: cardDetails.last_name,
      card_number: cardDetails.card_number,
      cvv_number: cardDetails.cvv_number,
      exp_month: cardDetails.exp_month,
      exp_year: cardDetails.exp_year,
      pay_amount: payAmount,
    };

    if (process.env.NODE_ENV !== "prod") {
      payload.card_details.process_id =
        cardDetails.card_number === "4111111111111111" &&
        cardDetails.cvv_number === "123"
          ? "99"
          : "";
    }
  }

  const organizeSupplements = (category) => {
    return cartItems
      ?.filter((item) => item.supplement?.category === category)
      .reduce((acc, item) => {
        const guests = [...(item.adults || []), ...(item.children || [])];
        guests.forEach((guest) => {
          if (!acc[guest.guest_id]) {
            acc[guest.guest_id] = [];
          }
          acc[guest.guest_id].push({
            id: item.supplement.id || item.supplement.child?.id,
            quantity: guest.quantity,
            price:
              item.supplement.farecode_price ||
              item.supplement.child?.farecode_price,
          });
        });
        return acc;
      }, {});
  };

  const onboard = organizeSupplements("OnBoard");
  const onshore = organizeSupplements("OnShore");

  if (Object.keys(onboard).length || Object.keys(onshore).length) {
    payload.supplement_details = {
      onboard: Object.keys(onboard).map((guestId) => ({
        [guestId]: onboard[guestId],
      })),
      onshore: Object.keys(onshore).map((guestId) => ({
        [guestId]: onshore[guestId],
      })),
    };
  }

  const cabin_upgrade = cartItems
    .map((item) => {
      if (item?.stateroom?.category_id) {
        return {
          new_category_id: item.stateroom.category_id,
          price_difference: item.stateroom.diff_price,
          prev_room_id: item.prev_cabin.room_id,
          new_occupancy_count: item.stateroom.occupancy,
        };
      } else {
        return null;
      }
    })
    .filter(Boolean);

  if (cabin_upgrade.length) {
    payload.cabin_upgrade = cabin_upgrade;
  }

  return payload;
};
